import { ListaClientesPorEjecutivo, Header } from "../../components";
import "./stylesClientesCartera.scss";

export const ClientesCartera = () => (
  <div className="clientes-cartera-page">
    <Header leftContent={<h1 className="titulo">Cartera Clientes por Ejecutivo</h1>} />
    <div className="clientes-cartera-content">
      <ListaClientesPorEjecutivo />
    </div>
  </div>
);
